import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { Bar } from 'react-chartjs-2';
import { t } from '../../../utils/textUtils';
import { prepareProjectProgressChartData } from '../utils/chartHelpers';

const ProjectProgress = ({ activeProjects }) => {
  return (
    <Paper
      variant="outlined"
      sx={{ 
        p: 3, 
        borderRadius: 2, 
        height: '100%',
        minHeight: '350px',
        borderColor: 'divider',
        bgcolor: '#ffffff'
      }}
    >
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        mb: 2,
        borderBottom: '1px solid',
        borderColor: 'divider',
        pb: 1
      }}>
        <Typography variant="h6" sx={{ fontWeight: 600, color: '#0f172a' }}>
          {t('PROGRES PROYEK')}
        </Typography>
      </Box>
      <Box sx={{ 
        height: { xs: 220, sm: 250 }, 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        mt: 1
      }}>
        {activeProjects.length > 0 ? (
          <Bar 
            data={prepareProjectProgressChartData(activeProjects)} 
            options={{
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                y: {
                  beginAtZero: true,
                  max: 100,
                  title: {
                    display: true,
                    text: t('PROSENTASE (%)'),
                    font: {
                      size: 12,
                      weight: 'bold'
                    }
                  }
                },
                x: {
                  ticks: {
                    maxRotation: 45,
                    minRotation: 45,
                    font: {
                      size: 10
                    }
                  }
                }
              },
              plugins: {
                legend: {
                  position: 'top',
                  labels: {
                    boxWidth: 15,
                    padding: 10,
                    font: {
                      size: 11
                    }
                  }
                },
                tooltip: {
                  callbacks: {
                    label: (context) => {
                      const label = context.dataset.label || '';
                      const value = context.raw || 0;
                      return `${label}: ${value}%`;
                    }
                  }
                }
              }
            }}
          />
        ) : (
          <Typography variant="body2" color="text.secondary">
            {t('TIDAK ADA PROYEK AKTIF DITEMUKAN')}
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default ProjectProgress;
